import React from 'react'
import Responsive from 'react-responsive'
import { sizes } from 'themes'

const Tablet = props => <Responsive {...props} minWidth={sizes.tablet + 1} maxWidth={sizes.desktop} />

export { Tablet }
